module.exports = __webpack_public_path__ + "img/brasil-flag-disabled.1861fb32.png";